import React from 'react';
import Frame from 'react-frame-component';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../../../components/Button';
import { Flex } from '../../../components/Flex';
import i18n, { AppLangs } from '../../../i18n';
import { CreateAtiraLinkDto } from '../../../model/atira-link/dto/CreateAtiraLinkDto';
import { AtiraLinkThemes } from '../../../model/atira-link/types/AtiraLinkThemes.enum';
import { AtiraLinkPreviewPhoneEJSReadOnly } from './AtiraLinkPreviewPhoneEJSReadonly';

const Container = styled(Flex)`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledFrame = styled(Frame)`
  width: 93.5%;
  height: 97%;
  border: 0;
  margin: auto;
  border-radius: 8px;
`;

const PreviewButton = styled(Button)`
  position: absolute;
  inset: 1% 3%;
  font-weight: bold;
  background-color: transparent;
  z-index: 1;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  border-radius: 16px;

  &:hover {
    opacity: 1;
    background-color: #652d90dd;
  }
`;

type PhonePreviewIframeProps = {
  theme: AtiraLinkThemes;
  onPreview?: VoidFunction;
  userAtiraLink?: CreateAtiraLinkDto;
};

export const PhonePreviewIframe: React.FC<PhonePreviewIframeProps> = ({
  theme,
  onPreview,
  userAtiraLink,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <StyledFrame
        loading="lazy"
        mountTarget={`#root-${theme}`}
        initialContent={`<!DOCTYPE html>
        <html lang="en" style="height: 100%; overflow: hidden">
        <head>
        ${
          i18n.language === AppLangs.AR
            ? '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.rtl.min.css" integrity="sha384-dpuaG1suU0eT09tx5plTaGMLBsfDLzUCCUXOY2j/LSvXYuG6Bqs43ALlhIqAJVRb" crossOrigin="anonymous" />'
            : '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous" />'
        }
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css" integrity="sha512-Kc323vGBEqzTmouAECnVceyQqyqdsSiqLQISBL29aUW4U/M7pSPA/gEUZQqv1cwx4OnYxTxve5UMg5GT6L4JJg==" crossorigin="anonymous" referrerpolicy="no-referrer">
          <link rel="stylesheet" type="text/css" href="/style/${(theme || 'basic').toLowerCase()}.css">
        </head>
        <body style="height: 100%;">
          <div id="root-${theme}" style="height: 100%;"></div>
        </body>
        </html>`}
      >
        <AtiraLinkPreviewPhoneEJSReadOnly
          theme={theme}
          userAtiraLink={userAtiraLink}
        />
      </StyledFrame>

      {onPreview ? (
        <PreviewButton onClick={onPreview}>{t('common.preview')}</PreviewButton>
      ) : null}
    </Container>
  );
};
